import { FC } from 'react';
import {
    FooterWrap,
    Separator,
    WrapImagesValues,
    WrapItensText,
    WrapValuesText,
} from './styles';
import Logo from '../../assets/icons/logo_black.svg?react';
import Smartshare from '../../assets/icons/smartshare.svg?react';
import ReactIcon from '../ReactIcon';
import {
    LuAtSign,
    LuBriefcase,
    LuFacebook,
    LuInstagram,
    LuPhone,
    LuYoutube,
} from 'react-icons/lu';
import { MdOutlineWhatsapp, MdOutlineEmail } from 'react-icons/md';
import { redirectOwnerSearch } from '../../helpers/utils';
import { useToken } from '../../store/auth/tokenStore';

export const Footer: FC = () => {
    const redirectToLink = (url: string) => window.open(url, '_blank');
    const { token } = useToken();

    return (
        <FooterWrap>
            <section>
                <div>
                    <WrapImagesValues>
                        <Logo />
                        <Smartshare />
                        <a
                            href="Política-de-Privacidade---Site-SLB-SET.24.pdf"
                            style={{ marginTop: 'auto' }}
                            target="_blank"
                        >
                            Política de privacidade
                        </a>
                    </WrapImagesValues>

                    <WrapValuesText>
                        <WrapItensText>
                            <h2>Área do proprietário</h2>
                            <span
                                onClick={() =>
                                    redirectToLink(
                                        'https://mkt.surflandbrasil.com.br/multipropriedade'
                                    )
                                }
                            >
                                Seja proprietário
                            </span>

                            <h2>Clube Resort</h2>
                            <span
                                onClick={() =>
                                    redirectToLink(
                                        'https://surflandbrasil.com.br/park'
                                    )
                                }
                            >
                                Parque
                            </span>
                            <span
                                onClick={() =>
                                    // Com sessão, leva o login pelo token de passagem
                                    // (o mesmo do menu do usuário); sem sessão, abre o portal.
                                    token
                                        ? redirectOwnerSearch(token)
                                        : redirectToLink(import.meta.env.VITE_OWNER_URL)
                                }
                            >
                                Portal
                            </span>
                        </WrapItensText>

                        <WrapItensText>
                            <h2>Regras de Acesso</h2>
                            <span
                                onClick={() =>
                                    redirectToLink(
                                        'https://cdn.surflandbrasil.com.br/internal/regulamento.pdf'
                                    )
                                }
                            >
                                Parque Surfland
                            </span>

                            <h2>Trabalhe conosco</h2>
                            <span
                                onClick={() =>
                                    redirectToLink(
                                        'https://talentossurflandbrasil.rhgestor.com.br/vagas'
                                    )
                                }
                            >
                                <ReactIcon
                                    Icon={LuBriefcase}
                                    size={'1.25rem'}
                                />
                                Ver vagas
                            </span>
                        </WrapItensText>

                        <WrapItensText id="contatos-footer">
                            <h2>Contatos</h2>
                            <span
                                onClick={() =>
                                    redirectToLink('https://wa.me/5548992037446')
                                }
                            >
                                <ReactIcon
                                    Icon={MdOutlineWhatsapp}
                                    size={'1.25rem'}
                                />
                                (48) 99203-7446
                            </span>

                            <span
                                onClick={() =>
                                    redirectToLink('mailto:posvendas@surflandbrasil.com.br')
                                }
                            >
                                <ReactIcon
                                    Icon={MdOutlineEmail}
                                    size={'1.25rem'}
                                />
                                posvendas@surflandbrasil.com.br
                            </span>

                            <span
                                onClick={() =>
                                    redirectToLink('mailto:tac@surflandbrasil.com.br')
                                }
                            >
                                <ReactIcon
                                    Icon={MdOutlineEmail}
                                    size={'1.25rem'}
                                />
                                tac@surflandbrasil.com.br
                            </span>
                        </WrapItensText>
                    </WrapValuesText>
                </div>
                <Separator></Separator>
                <div aria-selected>
                    <WrapImagesValues aria-selected={true}>
                        <span>
                            © 2025 Surfland Brasil | Todos os direitos
                            reservados.
                        </span>
                        <p>
                            SURFLAND BRASIL GAROPABA PARK LTDA CNPJ
                            32.044.097/0001-20
                        </p>
                    </WrapImagesValues>

                    <WrapValuesText aria-selected>
                        <ReactIcon
                            Icon={LuInstagram}
                            size={'1.5rem'}
                            cursor={'pointer'}
                            onClick={() =>
                                redirectToLink(
                                    'https://www.instagram.com/surflandbrasil/'
                                )
                            }
                        />
                        <ReactIcon
                            Icon={LuFacebook}
                            size={'1.5rem'}
                            cursor={'pointer'}
                            onClick={() =>
                                redirectToLink(
                                    'https://www.facebook.com/surflandbrasil'
                                )
                            }
                        />
                        <ReactIcon
                            Icon={LuYoutube}
                            size={'1.5rem'}
                            cursor={'pointer'}
                            onClick={() =>
                                redirectToLink(
                                    'https://www.youtube.com/c/SurflandBrasil'
                                )
                            }
                        />
                    </WrapValuesText>
                </div>
            </section>
        </FooterWrap>
    );
};
